import {connect} from "react-redux";
import CreateOpportunities from "./create";
import {bindActionCreators} from "redux";
import {dropdownData} from "../../service/Account/action";
import {save, opportunityQuestion, getOpportunity} from "../../service/Opportunities/action";
import {documentUploadUrlPublic} from "../../service/fileUpload/action";
import {accountDetailsById} from "../../service/Account/action";

const mapStateToProps = (state) => ({
    dropdownValue:state.Dropdown.dropdownValue,
    saveDetails:state.Opportunitie.saveDetails,
    opportunityQuestionDetails:state.Opportunitie.opportunityQuestion,
    opportunityDetails:state.Opportunitie.opportunityDetails,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    accountDetails:state.Dropdown.accountDetailsById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            save,
            opportunityQuestion,
            getOpportunity,
            documentUploadUrlPublic,
            accountDetailsById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CreateOpportunities);
